import ReactDOM from "react-dom";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import './App.css';
import Stream from "./pages/Stream";
import MoviesOverview from "./pages/MoviesOverview";
import MovieDetail from "./pages/MovieDetail";
import ShowsOverview from "./pages/ShowsOverview";
import ShowsSeasonOverview from "./pages/ShowsSeasonOverview";
import ShowsSeasonEpisodes from "./pages/ShowsSeasonEpisodes";
import ShowEpisodeOverview from "./pages/ShowEpisodeOverview";
import EpisodeStream from "./pages/EpisodeStream";
import Login from "./pages/login";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/movies" element={<MoviesOverview />} />
        <Route exact path="/movie/stream/:uuid" element={<Stream />} />
        <Route exact path="/movie/detail/:uuid" element={<MovieDetail />} />
        <Route exact path="/shows" element={<ShowsOverview />} />
        <Route exact path="/shows/:uuid" element={<ShowsSeasonOverview />} />
        <Route exact path="/shows/season/:uuid" element={<ShowsSeasonEpisodes />} />
        <Route exact path="/shows/episode/overview/:uuid" element={<ShowEpisodeOverview />} />
        <Route exact path="/shows/episode/stream/:uuid" element={<EpisodeStream />} />
        <Route path="*" element={<MoviesOverview />} />
      </Routes>
    </BrowserRouter>
  );
}

ReactDOM.render(<App />, document.getElementById("root"));
